import { connectHits } from 'instantsearch.js/es/connectors';
import { displayIfHidden } from '../dom/display-if-hidden';

/**
 * Mets à jour la liste d'options pour l'input
 *
 * @param {array} hits
 * @param {string} hitContainer
 * @param {HTMLInputElement} inputElement
 * @param {string} dataContainer
 * @param {string} detailContainer
 * @param {string} customClasses
 *
 * @return {HTMLElement}
 */
const updateResultList = (
  hits,
  hitContainer,
  inputElement,
  dataContainer,
  detailContainer,
  customClasses
) => {
  const hitContainerElement = document.querySelector(hitContainer);
  hitContainerElement.innerHTML = '';

  hits.forEach((hit) => {
    const element = document.createElement('div');
    element.className = customClasses;
    element.innerText = `${hit.chassis}`;
    hitContainerElement.appendChild(element);
    element.addEventListener('click', (event) => {
      updateDetailView(hit, inputElement, dataContainer, detailContainer);
      clearSuggestionList(hitContainer);
      fillInput(inputElement, event.target.innerText);
    });
  });

  return hitContainerElement;
};

/**
 * Vide les suggestions de résultat
 *
 * @param {string} hitContainer
 */
const clearSuggestionList = (hitContainer) => {
  const hitContainerElement = document.querySelector(hitContainer);
  hitContainerElement.innerHTML = '';
};

/**
 * Vide les détails
 *
 * @param {string} detailContainer
 */
const clearDetailView = (detailContainer) => {
  const detailElement = document.querySelector(detailContainer);
  detailElement.innerHTML = '';
};

/**
 * Mets à jour la liste de suggestions
 *
 * @param {array} hit
 * @param {string} input
 * @param {string} dataContainer
 * @param {string} detailContainer
 *
 * @returns {HTMLElement}
 */
const updateDetailView = (hit, input, dataContainer, detailContainer) => {
  const detailElement = document.querySelectorAll(dataContainer);
  const millesime = 2000 + parseInt(hit.millesime, 10);
  const data = [hit.chassis, millesime, hit.gamme, hit.modele];

  detailElement.forEach((element, index) => {
    element.innerText = data[index];
  });

  displayIfHidden(detailContainer);

  input.blur();

  return detailElement;
};

/**
 * Remplit l'input avec la valeur fournie
 *
 * @param {string|HTMLInputElement} inputContainer
 * @param {string} value
 */
const fillInput = (inputContainer, value) => {
  let inputElement = inputContainer;
  if (typeof inputContainer === 'string') {
    inputElement = document.querySelector(inputContainer);
  }
  inputElement.value = value;
};

/**
 * Créée un widget de hits custom
 *
 * @param {Object} renderOptions
 * @param {Object[]} renderOptions.hits
 * @param {string} renderOptions.hits.chassis
 * @param {string} renderOptions.hits.gamme
 * @param {string} renderOptions.hits.id
 * @param {string} renderOptions.hits.millesime
 * @param {string} renderOptions.hits.modele
 * @param {string} renderOptions.hits.objectID
 * @param {number} renderOptions.hits.__position
 * @param {Object} renderOptions.hits._highlightResult
 * @param {Object} renderOptions.results
 * @param {Object} renderOptions.widgetParams
 * @param {string} renderOptions.widgetParams.input
 * @param {string} renderOptions.widgetParams.dataContainer
 * @param {string} renderOptions.widgetParams.detailContainer
 * @param {string} renderOptions.widgetParams.hitContainer
 * @param {string} renderOptions.widgetParams.customClasses
 */
const renderHits = (renderOptions) => {
  const { hits, results } = renderOptions;
  const {
    input,
    dataContainer,
    detailContainer,
    hitContainer,
    customClasses,
  } = renderOptions.widgetParams;
  const inputElement = document.querySelector(input);

  if (
    typeof hits !== 'undefined' &&
    typeof hits[0] !== 'undefined' &&
    results.query !== ''
  ) {
    updateResultList(
      hits,
      hitContainer,
      inputElement,
      dataContainer,
      detailContainer,
      customClasses
    );
  } else if (typeof results !== 'undefined' && results.query === '') {
    // Si la requete est vide, on enleve les options de la datalist
    clearSuggestionList(hitContainer);
    clearDetailView(dataContainer);
  }
};

export const customHits = connectHits(renderHits);
